import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';

// export const apiOrigin =
//   process.env.NODE_ENV === 'development'
//     ? 'http://test.smshj.com:7001'
//     : //? 'https://api.cabinet.smshj.com'
//       'https://kmgapi.test.smshj.com';

export const apiOrigin ='https://kmgapi.test.smshj.com'
const httpLink = createHttpLink({
  uri: `${apiOrigin}/graphql`,
});

const authLink = setContext(async (_, { headers }) => {
  const accessToken = localStorage.getItem('token');

  // 设置token
  const authorizationHeader = accessToken ? { authorization: `Bearer ${accessToken}` } : {};

  return {
    headers: {
      ...headers,
      ...authorizationHeader,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({ addTypename: false }),
});

export const makeClient = () => client;

export default client;
